import { getDomainGA4Analytics } from "@mp-commons/config/GA4Accounts.js";
import { NielsenVideoMeasurementTrackingIds } from "@mp-commons/config/NielsenAccounts.js";
import { getSecondLevelDomain } from "@mp-commons/lib/utils/DomainNameUtils.js";
import { getCPProductFromHostname, getYMHostByCPProduct } from "@mp-commons/config/CPProducts.js";
import { CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";
import { ExternallyPassedContentAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { NielsenCollectorFactory } from "@mp-commons/modules/stats/collectors/NielsenCollector.js";
import { AttachableEventMapper, MapperConfigFlags } from "@mp-commons/modules/stats/mappers/CommonEventMapper.js";
import { GA4Mapper } from "../../stats/mappers/GA4Mapper.js";
import { MegarideCSStreamingTagMapper } from "../../stats/mappers/MegarideCSStreamingTagMapper.js";
import { MegarideNielsenMapper } from "../../stats/mappers/MegarideNielsenMapper.js";
import { MegarideYMStatsMapper } from "../../stats/mappers/MegarideYMStatsMapper.js";
import { GDPRPromise } from "@mp-commons/modules/ads/GDPR.js";

export interface GenericStatsProviderFlags extends MapperConfigFlags {
    enable: boolean
}


export interface StatsConfig  {

    ga4: GenericStatsProviderFlags,
    nielsen: {enable: boolean},
    comscore: GenericStatsProviderFlags,
    ymstats: GenericStatsProviderFlags,
    playerName: string
}


export function StatsMapperBuilder(win: Window,
                                    embedType: CP_EmbedType,
                                    config: StatsConfig,
                                    externalData?: ExternallyPassedContentAdData
                                    ): AttachableEventMapper[] {
    const product = getCPProductFromHostname(win.location.hostname);
    const seclev = getSecondLevelDomain(win.location.hostname);
    
    
                            

    const mappers: AttachableEventMapper[] = [];

    if(config.ga4.enable) {
        const ga4config = getDomainGA4Analytics(seclev);
        mappers.push(new GA4Mapper(win,embedType,{
            ...ga4config,
            ...config.ga4
        }));
    }

    if(config.nielsen.enable && product in NielsenVideoMeasurementTrackingIds) {
        const trackingIdMapper = NielsenVideoMeasurementTrackingIds[product];
        const nielsenfactory = new NielsenCollectorFactory(win,trackingIdMapper,config.playerName);
        mappers.push(new MegarideNielsenMapper(nielsenfactory));
    }
    if(config.ymstats.enable) {
        const ymHostname = getYMHostByCPProduct(win.location.hostname,seclev,product);
        mappers.push(new MegarideYMStatsMapper(win,{
            ...config.ymstats,
            embedType: embedType,
            playerName: config.playerName,
            ymHostname: ymHostname,
            product: product
        }))
    }

    if(config.comscore.enable) {
        const cscore = new MegarideCSStreamingTagMapper(win,{
            publisherId: "18904044",
            debug: true
        },GDPRPromise(),externalData);
        mappers.push(cscore);
    }


    return mappers;
}


